import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import LogoWordmark from "./LogoWordmark";
import { NAV_LINKS, MAILTO_HREF } from "@/lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `font-display text-sm tracking-wide uppercase transition-colors ${
      isActive ? "text-brick-light" : "text-offwhite/85 hover:text-offwhite"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-charcoal shadow-md">
      <div className="section-container flex h-20 items-center justify-between">
        <NavLink to="/" onClick={() => setOpen(false)} aria-label="VCO Group home">
          <LogoWordmark />
        </NavLink>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} className={linkClass} end={link.to === "/"}>
              {link.label}
            </NavLink>
          ))}
          <a
            href={MAILTO_HREF}
            className="rounded bg-brick px-5 py-2.5 font-display text-sm uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
          >
            Get In Touch
          </a>
        </nav>

        <button
          className="text-offwhite md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-charcoal-light bg-charcoal md:hidden">
          <nav className="section-container flex flex-col gap-1 py-4">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={linkClass}
                onClick={() => setOpen(false)}
              >
                <div className="py-3">{link.label}</div>
              </NavLink>
            ))}
            <a
              href={MAILTO_HREF}
              className="mt-2 rounded bg-brick px-5 py-3 text-center font-display text-sm uppercase tracking-wide text-offwhite"
            >
              Get In Touch
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
